export default "__VITE_ASSET__CCzoLZ4A__"